import {Moment} from 'moment';
/**
 * Created by Rodrigo Quesada on 30/03/17.
 */

//region Text
export function formatOrEmpty<T>(value?: T, format?: (T) => string): string {
    let result = '';
    if (value) {
        const stringValue = value.toString();
        if (stringValue.length > 0) result = (format ? format(stringValue) : stringValue);
    }
    return result;
}

export function separatedBy(separator: string, ...values: (any | undefined)[]) {
    const stringValues: string[] = values.filter(it => !!it).map(it => it.toString());

    return stringValues.filter(it => it && it.length > 0).join(separator);
}

export function separatedBySpace(...values: (any | undefined)[]) {
    return separatedBy(' ', ...values);
}
//endregion

//region Date
export function formatMonthYear(date: Moment | undefined, defaultValue: string = ''): string { return date ? date.format('MM/YYYY') : defaultValue; }

export function formatMonthDayYear(date: Moment | undefined, defaultValue: string = ''): string { return date ? date.format('MM/DD/YYYY') : defaultValue; }

export function toOrderValue(date?: Moment, upToPresent?: boolean): number { return !upToPresent && date ? +date : Number.MAX_VALUE; }
//endregion



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/shared/utils.ts